module.exports = __webpack_public_path__ + "img/cheboshi.056e75e7.png";